import React from 'react';
import PropTypes from 'prop-types';

import styles from './TagList.module.scss';

const TagList = ({ tags, onClick }) => (
    <div className={styles['tag-list-component']}>
        {(tags || []).map((tag) => (
            <a key={tag.url} title={tag.title} href={tag.url} onClick={onClick}>
                {tag.name}
            </a>
        ))}
    </div>
);

TagList.propTypes = {
    onClick: PropTypes.func,
    tags: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            url: PropTypes.string,
            title: PropTypes.string,
        })
    ),
};

export default TagList;
